import {
  Home,
  Box,
  DollarSign,
  Tag,
  Clipboard,
  Camera,
  AlignLeft,
  UserPlus,
  Users,
  Chrome,
  BarChart,
  Settings,
  Archive,
  LogIn,
  RotateCcw,
  CreditCard,
} from "react-feather";

export const MENUITEMSFORADMIN = [
  {
    path: "/dashboard",
    title: "Dashboard",
    icon: Home,
    type: "link",
    badgeType: "primary",
    active: false,
  },
  {
    title: "Orders",
    icon: Clipboard,
    type: "sub",
    active: false,
    children: [
      { path: "/orders/Processing", title: "Processing", type: "link" },
      { path: "/orders/Confirmed", title: "Confirmed", type: "link" },
      { path: "/orders/Packing", title: "Packing", type: "link" },
      { path: "/orders/On the way", title: "On the way", type: "link" },
      {
        path: "/orders/Delivered",
        title: "Delivered",
        type: "link",
      },
      {
        path: "/orders/Partial Delivered",
        title: "Partial Delivered",
        type: "link",
      },
      {
        path: "/orders/Cancelled",
        title: "Cancelled",
        type: "link",
      },
      {
        path: "/orders/All Orders",
        title: "All Orders",
        type: "link",
      },
    ],
  },
  {
    title: "Pre Orders",
    icon: Clipboard,
    type: "sub",
    active: false,
    children: [
      { path: "/pre-orders/new", title: "New Orders", type: "link" },
      { path: "/pre-orders/picked-orders", title: "Picked Orders", type: "link" },
      { path: "/pre-orders/purchased", title: "Purchased", type: "link" },
      { path: "/pre-orders/received-in-warehouse", title: "Abroad Warehouse", type: "link" },
      { path: "/pre-orders/ready-for-fly", title: "Ready For Fly", type: "link" },
      { path: "/pre-orders/bangladesh-customs", title: "Bangladesh Customs", type: "link" },
      { path: "/pre-orders/custom-released", title: "Custom Released", type: "link" },
      { path: "/pre-orders/Zapai-warehouse", title: "Zapai Warehouse", type: "link" },
      { path: "/pre-orders/delivered", title: "Delivered", type: "link" },
      { path: "/pre-orders/rejected", title: "Rejected", type: "link" },
      { path: "/pre-orders/all-orders", title: "All Orders", type: "link" },
      { path: "/1688-orders/payment-link", title: "1688 Payment Link", type: "link" },
    ],
  },
  {
    title: "Cash in/Cash out",
    icon: DollarSign,
    type: "sub",
    active: false,
    children: [
      {
        path: "/expense/daily-expense",
        title: new Date().toDateString(),
        type: "link",
      },
      {
        path: "/expense/expense-history",
        title: "History",
        type: "link",
      },

      {
        path: "/expense/office",
        title: "Office",
        type: "link",
      },

      {
        path: "/expense/salary",
        title: "Salary",
        type: "link",
      },
      {
        path: "/expense/refunds",
        title: "Refund",
        type: "link",
      },
      {
        path: "/expense/daily-cost",
        title: "Daily Cost",
        type: "link",
      },
      {
        path: "/expense/lot-transport",
        title: "Transport",
        type: "link",
      },
      {
        path: "/expense/courier",
        title: "Courier Charge",
        type: "link",
      },
      {
        path: "/expense/shipping",
        title: "Shipping",
        type: "link",
      },
      {
        path: "/expense/boosting",
        title: "Boosting/Promotion",
        type: "link",
      },
      {
        path: "/expense/buy-products",
        title: "Buy Products",
        type: "link",
      },
      {
        path: "/expense/invest",
        title: "Invest",
        type: "link",
      },

      {
        title: "Loans",
        type: "sub",
        active: false,
        children: [
          {
            title: "Monthly",
            type: "link",
            path: "/expense/loans",
          },
          {
            title: "Customer wise",
            type: "link",
            path: "/expense/loans-by-customers",
          },
        ],
      },
      {
        path: "/expense/order",
        title: "All Sells",
        type: "link",
      },
      {
        path: "/expense/employee",
        title: "Employee",
        type: "link",
      },
    ],
  },
  {
    title: "Cash in/out History",
    icon: Clipboard,
    type: "sub",
    active: false,
    children: [
      {
        path: "/expense/approve-expense",
        title: "Pending",
        type: "link",
      },
      {
        path: "/expense/expense-history",
        title: "Monthly",
        type: "link",
      },

      {
        path: "/expense/office",
        title: "Office",
        type: "link",
      },
      {
        path: "/expense/salary",
        title: "Salary",
        type: "link",
      },
      {
        path: "/expense/refunds",
        title: "Refund",
        type: "link",
      },

      {
        path: "/expense/daily-cost",
        title: "Daily Cost",
        type: "link",
      },
      {
        path: "/expense/lot-transport",
        title: "Transport",
        type: "link",
      },
      {
        path: "/expense/courier",
        title: "Courier Charge",
        type: "link",
      },
      {
        path: "/expense/shipping",
        title: "Shipping",
        type: "link",
      },
      {
        path: "/expense/boosting",
        title: "Boosting/Promotion",
        type: "link",
      },
      {
        path: "/expense/buy-products",
        title: "Buy Products",
        type: "link",
      },
      {
        path: "/expense/invest",
        title: "Invest",
        type: "link",
      },
      {
        title: "Loans",
        type: "sub",
        active: false,
        children: [
          {
            title: "Monthly",
            type: "link",
            path: "/expense/loans",
          },
          {
            title: "Customer wise",
            type: "link",
            path: "/expense/loans-by-customers",
          },
        ],
      },
      {
        path: "/expense/order",
        title: "All Sells",
        type: "link",
      },
      {
        path: "/expense/employee",
        title: "Employee",
        type: "link",
      },
    ],
  },
  {
    title: "Cash Summary",
    icon: Clipboard,
    type: "sub",
    active: false,
    children: [
      {
        path: "/cash-summary",
        title: "Monthly",
        type: "link",
      },
    ],
  },
  {
    path: "/refund-requests",
    title: "Refund Requests",
    icon: RotateCcw,
    type: "link",
    badgeType: "primary",
    active: false,
  },
  {
    title: "Products",
    icon: Box,
    type: "sub",
    active: false,
    children: [
      {
        path: "/products/physical/all-products",
        title: "All Products",
        type: "link",
      },

      {
        path: "/products/physical/add-product",
        title: "Add Product",
        type: "link",
      },
      {
        path: "/products/physical/brands",
        title: "Brands",
        type: "link",
      },
      {
        path: "/products/physical/categories",
        title: "Categories",
        type: "link",
      },
      {
        path: "/products/physical/campaigns",
        title: "Campaigns",
        type: "link",
      },
      {
        path: "/products/physical/banners",
        title: "Banners",
        type: "link",
      },
      {
        path: "/products/physical/shop-by-concern",
        title: "Shop By Concern",
        type: "link",
      },
      {
        path: "/products/physical/attributes",
        title: "Attributes",
        type: "link",
      },
      {
        path: "/products/physical/reviews",
        title: "Reviews",
        type: "link",
      },
      {
        path: "/products/physical/reviews-screenshot",
        title: "Review Screenshot",
        type: "link",
      },
      {
        path: "/products/physical/announcements",
        title: "Announcements",
        type: "link",
      },
      {
        path: "/products/physical/restock-dashboard",
        title: "Restock Dashboard",
        type: "link",
      },
    ],
  },
  {
    title: "Coupons",
    icon: Box,
    type: "sub",
    active: false,
    children: [
      {
        path: "/coupons/physical/all-coupons",
        title: "All Coupons",
        type: "link",
      },
    ],
  },

  // {
  //     title: 'Media', path: '/media', icon: Camera, type: 'link', active: false
  // },
  // {
  //     title: 'Menus', icon: AlignLeft, type: 'sub', active: false, children: [
  //         { path: '/menus/list-menu', title: 'List Menu', type: 'link' },
  //         { path: '/menus/create-menu', title: 'Create Menu', type: 'link' },
  //     ]
  // },
  {
    title: "Users",
    icon: UserPlus,
    type: "sub",
    active: false,
    children: [
      { path: "/users/list-user", title: "User List", type: "link" },
      // { path: '/users/create-user', title: 'Create User', type: 'link' },
    ],
  },
  {
    title: "Admins",
    icon: UserPlus,
    type: "sub",
    active: false,
    children: [
      { path: "/admins/list-admin", title: "All Admins", type: "link" },
      // { path: '/users/create-user', title: 'Create User', type: 'link' },
    ],
  },

  {
    title: "Currency Converter",
    path: "/localization/currency-rates",
    icon: DollarSign,
    type: "link",
    active: false,
  },
  {
    title: "Steadfast Payments",
    path: "/steadfast/payments",
    icon: CreditCard,
    type: "link",
    active: false,
  },
  {
    title: "Register a manager",
    path: "/admins/register",
    icon: LogIn,
    type: "link",
    active: false,
  },
  {
    title: "Wholesale Management",
    icon: Clipboard,
    type: "sub",
    active: false,
    children: [
      { title: "Invoice", type: "link", path: "/business-consultancy/sourcing-invoice-months" },
      { title: "Order Agents", type: "link", path: "/business-consultancy/sourcing-invoice-agents" },
    ],
  },
];
export const MENUITEMSFOREMPLOYEE = [
  {
    path: "/dashboard",
    title: "Dashboard",
    icon: Home,
    type: "link",
    badgeType: "primary",
    active: false,
  },
  {
    title: "Orders",
    icon: Clipboard,
    type: "sub",
    active: false,
    children: [
      { path: "/orders/Processing", title: "Processing", type: "link" },
      { path: "/orders/Confirmed", title: "Confirmed", type: "link" },
      { path: "/orders/Packing", title: "Packing", type: "link" },
      { path: "/orders/On the way", title: "On the way", type: "link" },
      {
        path: "/orders/Delivered",
        title: "Delivered",
        type: "link",
      },
      {
        path: "/orders/Partial Delivered",
        title: "Partial Delivered",
        type: "link",
      },
      {
        path: "/orders/Cancelled",
        title: "Cancelled",
        type: "link",
      },
      {
        path: "/orders/All Orders",
        title: "All Orders",
        type: "link",
      },
    ],
  },
  {
    title: "Pre Orders",
    icon: Clipboard,
    type: "sub",
    active: false,
    children: [
      { path: "/pre-orders/new", title: "New Orders", type: "link" },
      { path: "/pre-orders/picked-orders", title: "Picked Orders", type: "link" },
      { path: "/pre-orders/purchased", title: "Purchased", type: "link" },
      { path: "/pre-orders/received-in-warehouse", title: "Abroad Warehouse", type: "link" },
      { path: "/pre-orders/ready-for-fly", title: "Ready For Fly", type: "link" },
      { path: "/pre-orders/bangladesh-customs", title: "Bangladesh Customs", type: "link" },
      { path: "/pre-orders/custom-released", title: "Custom Released", type: "link" },
      { path: "/pre-orders/Zapai-warehouse", title: "Zapai Warehouse", type: "link" },
      { path: "/pre-orders/delivered", title: "Delivered", type: "link" },
      { path: "/pre-orders/rejected", title: "Rejected", type: "link" },
      { path: "/pre-orders/all-orders", title: "All Orders", type: "link" },
      { path: "/1688-orders/payment-link", title: "1688 Payment Link", type: "link" },
    ],
  },

  {
    path: "/refund-requests",
    title: "Refund Requests",
    icon: RotateCcw,
    type: "link",
    badgeType: "primary",
    active: false,
  },
  {
    title: "Products",
    icon: Box,
    type: "sub",
    active: false,
    children: [
      {
        path: "/products/physical/all-products",
        title: "All Products",
        type: "link",
      },

      {
        path: "/products/physical/add-product",
        title: "Add Product",
        type: "link",
      },
      {
        path: "/products/physical/brands",
        title: "Brands",
        type: "link",
      },
      {
        path: "/products/physical/categories",
        title: "Categories",
        type: "link",
      },

      {
        path: "/products/physical/attributes",
        title: "Attributes",
        type: "link",
      },
      {
        path: "/products/physical/reviews",
        title: "Reviews",
        type: "link",
      },
      {
        path: "/products/physical/reviews-screenshot",
        title: "Review Screenshot",
        type: "link",
      },
    ],
  },

  {
    title: "Users",
    icon: UserPlus,
    type: "sub",
    active: false,
    children: [
      { path: "/users/list-user", title: "User List", type: "link" },
      // { path: '/users/create-user', title: 'Create User', type: 'link' },
    ],
  },
];

export const MENUITEMSFORACCOUNTS = [
  {
    path: "/dashboard",
    title: "Dashboard",
    icon: Home,
    type: "link",
    badgeType: "primary",
    active: false,
  },
  {
    title: "Orders",
    icon: Clipboard,
    type: "sub",
    active: false,
    children: [
      { path: "/orders/Processing", title: "Processing", type: "link" },
      { path: "/orders/Confirmed", title: "Confirmed", type: "link" },
      { path: "/orders/Packing", title: "Packing", type: "link" },
      { path: "/orders/On the way", title: "On the way", type: "link" },
      {
        path: "/orders/Delivered",
        title: "Delivered",
        type: "link",
      },
      {
        path: "/orders/Partial Delivered",
        title: "Partial Delivered",
        type: "link",
      },
      {
        path: "/orders/Cancelled",
        title: "Cancelled",
        type: "link",
      },
      {
        path: "/orders/All Orders",
        title: "All Orders",
        type: "link",
      },
    ],
  },
  {
    title: "Pre Orders",
    icon: Clipboard,
    type: "sub",
    active: false,
    children: [
      { path: "/pre-orders/new", title: "New Orders", type: "link" },
      { path: "/pre-orders/picked-orders", title: "Picked Orders", type: "link" },
      { path: "/pre-orders/purchased", title: "Purchased", type: "link" },
      { path: "/pre-orders/received-in-warehouse", title: "Abroad Warehouse", type: "link" },
      { path: "/pre-orders/ready-for-fly", title: "Ready For Fly", type: "link" },
      { path: "/pre-orders/bangladesh-customs", title: "Bangladesh Customs", type: "link" },
      { path: "/pre-orders/custom-released", title: "Custom Released", type: "link" },
      { path: "/pre-orders/Zapai-warehouse", title: "Zapai Warehouse", type: "link" },
      { path: "/pre-orders/delivered", title: "Delivered", type: "link" },
      { path: "/pre-orders/rejected", title: "Rejected", type: "link" },
      { path: "/pre-orders/all-orders", title: "All Orders", type: "link" },
      { path: "/1688-orders/payment-link", title: "1688 Payment Link", type: "link" },
    ],
  },
  {
    title: "Cash in/Cash out",
    icon: DollarSign,
    type: "sub",
    active: false,
    children: [
      {
        path: "/expense/daily-expense",
        title: new Date().toDateString(),
        type: "link",
      },
      {
        path: "/expense/expense-history",
        title: "History",
        type: "link",
      },

      {
        path: "/expense/office",
        title: "Office",
        type: "link",
      },

      {
        path: "/expense/salary",
        title: "Salary",
        type: "link",
      },
      {
        path: "/expense/refunds",
        title: "Refund",
        type: "link",
      },
      {
        path: "/expense/daily-cost",
        title: "Daily Cost",
        type: "link",
      },
      {
        path: "/expense/lot-transport",
        title: "Transport",
        type: "link",
      },
      {
        path: "/expense/courier",
        title: "Courier Charge",
        type: "link",
      },
      {
        path: "/expense/shipping",
        title: "Shipping",
        type: "link",
      },
      {
        path: "/expense/boosting",
        title: "Boosting/Promotion",
        type: "link",
      },
      {
        path: "/expense/buy-products",
        title: "Buy Products",
        type: "link",
      },
      {
        path: "/expense/invest",
        title: "Invest",
        type: "link",
      },

      {
        title: "Loans",
        type: "sub",
        active: false,
        children: [
          {
            title: "Monthly",
            type: "link",
            path: "/expense/loans",
          },
          {
            title: "Customer wise",
            type: "link",
            path: "/expense/loans-by-customers",
          },
        ],
      },
      {
        path: "/expense/order",
        title: "All Sells",
        type: "link",
      },
      {
        path: "/expense/employee",
        title: "Employee",
        type: "link",
      },
    ],
  },

  {
    title: "Cash Summary",
    icon: Clipboard,
    type: "sub",
    active: false,
    children: [
      {
        path: "/cash-summary",
        title: "Monthly",
        type: "link",
      },
    ],
  },

  {
    title: "Products",
    icon: Box,
    type: "sub",
    active: false,
    children: [
      {
        path: "/products/physical/all-products",
        title: "All Products",
        type: "link",
      },

      {
        path: "/products/physical/add-product",
        title: "Add Product",
        type: "link",
      },
      {
        path: "/products/physical/brands",
        title: "Brands",
        type: "link",
      },
      {
        path: "/products/physical/categories",
        title: "Categories",
        type: "link",
      },
      {
        path: "/products/physical/campaigns",
        title: "Campaigns",
        type: "link",
      },
      {
        path: "/products/physical/banners",
        title: "Banners",
        type: "link",
      },
      {
        path: "/products/physical/shop-by-concern",
        title: "Shop By Concern",
        type: "link",
      },
      {
        path: "/products/physical/attributes",
        title: "Attributes",
        type: "link",
      },
      {
        path: "/products/physical/reviews",
        title: "Reviews",
        type: "link",
      },
      {
        path: "/products/physical/reviews-screenshot",
        title: "Review Screenshot",
        type: "link",
      },
      {
        path: "/products/physical/announcements",
        title: "Announcements",
        type: "link",
      },
      {
        path: "/products/physical/restock-dashboard",
        title: "Restock Dashboard",
        type: "link",
      },
    ],
  },

  {
    title: "Users",
    icon: UserPlus,
    type: "sub",
    active: false,
    children: [
      { path: "/users/list-user", title: "User List", type: "link" },
      // { path: '/users/create-user', title: 'Create User', type: 'link' },
    ],
  },
  {
    title: "Wholesale Management",
    icon: Clipboard,
    type: "sub",
    active: false,
    children: [
      { title: "Invoice", type: "link", path: "/business-consultancy/sourcing-invoice-months" },
      { title: "Order Agents", type: "link", path: "/business-consultancy/sourcing-invoice-agents" },
    ],
  },
];

export const MENUITEMSFOROFFICERS = [
  {
    path: "/dashboard",
    title: "Dashboard",
    icon: Home,
    type: "link",
    badgeType: "primary",
    active: false,
  },
  {
    title: "Orders",
    icon: Clipboard,
    type: "sub",
    active: false,
    children: [
      { path: "/orders/Processing", title: "Processing", type: "link" },
      { path: "/orders/Confirmed", title: "Confirmed", type: "link" },
      { path: "/orders/Packing", title: "Packing", type: "link" },
      { path: "/orders/On the way", title: "On the way", type: "link" },
      {
        path: "/orders/Delivered",
        title: "Delivered",
        type: "link",
      },
      {
        path: "/orders/Partial Delivered",
        title: "Partial Delivered",
        type: "link",
      },
      {
        path: "/orders/Cancelled",
        title: "Cancelled",
        type: "link",
      },
      {
        path: "/orders/All Orders",
        title: "All Orders",
        type: "link",
      },
    ],
  },
  {
    title: "Pre Orders",
    icon: Clipboard,
    type: "sub",
    active: false,
    children: [
      { path: "/pre-orders/new", title: "New Orders", type: "link" },
      { path: "/pre-orders/picked-orders", title: "Picked Orders", type: "link" },
      { path: "/pre-orders/purchased", title: "Purchased", type: "link" },
      { path: "/pre-orders/received-in-warehouse", title: "Abroad Warehouse", type: "link" },
      { path: "/pre-orders/ready-for-fly", title: "Ready For Fly", type: "link" },
      { path: "/pre-orders/bangladesh-customs", title: "Bangladesh Customs", type: "link" },
      { path: "/pre-orders/custom-released", title: "Custom Released", type: "link" },
      { path: "/pre-orders/Zapai-warehouse", title: "Zapai Warehouse", type: "link" },
      { path: "/pre-orders/delivered", title: "Delivered", type: "link" },
      { path: "/pre-orders/rejected", title: "Rejected", type: "link" },
      { path: "/pre-orders/all-orders", title: "All Orders", type: "link" },
      { path: "/1688-orders/payment-link", title: "1688 Payment Link", type: "link" },
    ],
  },
  {
    title: "Cash in/Cash out",
    icon: DollarSign,
    type: "sub",
    active: false,
    children: [
      {
        path: "/expense/daily-expense",
        title: new Date().toDateString(),
        type: "link",
      },
      {
        path: "/expense/expense-history",
        title: "History",
        type: "link",
      },

      {
        path: "/expense/office",
        title: "Office",
        type: "link",
      },

      {
        path: "/expense/salary",
        title: "Salary",
        type: "link",
      },
      {
        path: "/expense/refunds",
        title: "Refund",
        type: "link",
      },
      {
        path: "/expense/daily-cost",
        title: "Daily Cost",
        type: "link",
      },
      {
        path: "/expense/lot-transport",
        title: "Transport",
        type: "link",
      },
      {
        path: "/expense/courier",
        title: "Courier Charge",
        type: "link",
      },
      {
        path: "/expense/shipping",
        title: "Shipping",
        type: "link",
      },
      {
        path: "/expense/boosting",
        title: "Boosting/Promotion",
        type: "link",
      },
      {
        path: "/expense/buy-products",
        title: "Buy Products",
        type: "link",
      },
      {
        path: "/expense/invest",
        title: "Invest",
        type: "link",
      },

      {
        title: "Loans",
        type: "sub",
        active: false,
        children: [
          {
            title: "Monthly",
            type: "link",
            path: "/expense/loans",
          },
          {
            title: "Customer wise",
            type: "link",
            path: "/expense/loans-by-customers",
          },
        ],
      },
      {
        path: "/expense/order",
        title: "All Sells",
        type: "link",
      },
      {
        path: "/expense/employee",
        title: "Employee",
        type: "link",
      },
    ],
  },

  {
    title: "Cash Summary",
    icon: Clipboard,
    type: "sub",
    active: false,
    children: [
      {
        path: "/cash-summary",
        title: "Monthly",
        type: "link",
      },
    ],
  },

  {
    title: "Products",
    icon: Box,
    type: "sub",
    active: false,
    children: [
      {
        path: "/products/physical/all-products",
        title: "All Products",
        type: "link",
      },

      {
        path: "/products/physical/add-product",
        title: "Add Product",
        type: "link",
      },
      {
        path: "/products/physical/brands",
        title: "Brands",
        type: "link",
      },
      {
        path: "/products/physical/categories",
        title: "Categories",
        type: "link",
      },
      {
        path: "/products/physical/campaigns",
        title: "Campaigns",
        type: "link",
      },
      {
        path: "/products/physical/banners",
        title: "Banners",
        type: "link",
      },
      {
        path: "/products/physical/shop-by-concern",
        title: "Shop By Concern",
        type: "link",
      },
      {
        path: "/products/physical/attributes",
        title: "Attributes",
        type: "link",
      },
      {
        path: "/products/physical/reviews",
        title: "Reviews",
        type: "link",
      },
      {
        path: "/products/physical/reviews-screenshot",
        title: "Review Screenshot",
        type: "link",
      },
      {
        path: "/products/physical/announcements",
        title: "Announcements",
        type: "link",
      },
      {
        path: "/products/physical/restock-dashboard",
        title: "Restock Dashboard",
        type: "link",
      },
    ],
  },

  {
    title: "Users",
    icon: UserPlus,
    type: "sub",
    active: false,
    children: [
      { path: "/users/list-user", title: "User List", type: "link" },
      // { path: '/users/create-user', title: 'Create User', type: 'link' },
    ],
  },
];

export const MENUITEMSFORPARTNER = [
  {
    path: "/dashboard",
    title: "Dashboard",
    icon: Home,
    type: "link",
    badgeType: "primary",
    active: false,
  },
  {
    path: "/refund-requests",
    title: "Refund Requests",
    icon: RotateCcw,
    type: "link",
    badgeType: "primary",
    active: false,
  },
  {
    title: "Orders",
    icon: Clipboard,
    type: "sub",
    active: false,
    children: [
      { path: "/orders/Processing", title: "Processing", type: "link" },
      { path: "/orders/Confirmed", title: "Confirmed", type: "link" },
      { path: "/orders/Packing", title: "Packing", type: "link" },
      { path: "/orders/On the way", title: "On the way", type: "link" },
      { path: "/orders/Delivered", title: "Delivered", type: "link" },
      { path: "/orders/Partial Delivered", title: "Partial Delivered", type: "link" },
      { path: "/orders/Cancelled", title: "Cancelled", type: "link" },
      { path: "/orders/All Orders", title: "All Orders", type: "link" },
    ],
  },
  {
    title: "Pre Orders",
    icon: Clipboard,
    type: "sub",
    active: false,
    children: [
      { path: "/pre-orders/new", title: "New Orders", type: "link" },
      { path: "/pre-orders/picked-orders", title: "Picked Orders", type: "link" },
      { path: "/pre-orders/purchased", title: "Purchased", type: "link" },
      { path: "/pre-orders/received-in-warehouse", title: "Abroad Warehouse", type: "link" },
      { path: "/pre-orders/ready-for-fly", title: "Ready For Fly", type: "link" },
      { path: "/pre-orders/bangladesh-customs", title: "Bangladesh Customs", type: "link" },
      { path: "/pre-orders/custom-released", title: "Custom Released", type: "link" },
      { path: "/pre-orders/Zapai-warehouse", title: "Zapai Warehouse", type: "link" },
      { path: "/pre-orders/delivered", title: "Delivered", type: "link" },
      { path: "/pre-orders/rejected", title: "Rejected", type: "link" },
      { path: "/pre-orders/all-orders", title: "All Orders", type: "link" },
      { path: "/1688-orders/payment-link", title: "1688 Payment Link", type: "link" },
    ],
  },
  {
    title: "Cash in/Cash out",
    icon: DollarSign,
    type: "sub",
    active: false,
    children: [
      { path: "/expense/daily-expense", title: new Date().toDateString(), type: "link" },
      { path: "/expense/expense-history", title: "History", type: "link" },
      { path: "/expense/salary", title: "Salary", type: "link" },
      { path: "/expense/refunds", title: "Refund", type: "link" },
      { path: "/expense/lot-transport", title: "Transport", type: "link" },
      {
        title: "Loans",
        type: "sub",
        active: false,
        children: [
          { title: "Monthly", type: "link", path: "/expense/loans" },
          { title: "Customer wise", type: "link", path: "/expense/loans-by-customers" },
        ],
      },
      { path: "/expense/office", title: "Office", type: "link" },
      { path: "/expense/boosting", title: "Boosting/Promotion", type: "link" },
      { path: "/expense/invest", title: "Invest", type: "link" },
    ],
  },
  {
    title: "Cash in/out History",
    icon: Clipboard,
    type: "sub",
    active: false,
    children: [
      { path: "/expense/approve-expense", title: "Pending", type: "link" },
      { path: "/expense/expense-history", title: "Monthly", type: "link" },
      { path: "/expense/office", title: "Office", type: "link" },
      { path: "/expense/salary", title: "Salary", type: "link" },
      { path: "/expense/refunds", title: "Refund", type: "link" },
      { path: "/expense/daily-cost", title: "Daily Cost", type: "link" },
      { path: "/expense/lot-transport", title: "Transport", type: "link" },
      { path: "/expense/boosting", title: "Boosting/Promotion", type: "link" },
      { path: "/expense/invest", title: "Invest", type: "link" },
      {
        title: "Loans",
        type: "sub",
        active: false,
        children: [
          { title: "Monthly", type: "link", path: "/expense/loans" },
          { title: "Customer wise", type: "link", path: "/expense/loans-by-customers" },
        ],
      },
      { path: "/expense/employee", title: "Employee", type: "link" },
    ],
  },
  {
    title: "Cash Summary",
    icon: Clipboard,
    type: "sub",
    active: false,
    children: [
      { path: "/cash-summary", title: "Monthly", type: "link" },
    ],
  },
  {
    title: "Products",
    icon: Box,
    type: "sub",
    active: false,
    children: [
      { path: "/products/physical/all-products", title: "All Products", type: "link" },
      { path: "/products/physical/add-product", title: "Add Product", type: "link" },
      { path: "/products/physical/banners", title: "Banners", type: "link" },
      { path: "/products/physical/restock-dashboard", title: "Restock Dashboard", type: "link" },
    ],
  },
  {
    title: "Coupons",
    icon: Box,
    type: "sub",
    active: false,
    children: [
      { path: "/coupons/physical/all-coupons", title: "All Coupons", type: "link" },
    ],
  },
  {
    title: "Payment Request",
    icon: Clipboard,
    type: "sub",
    active: false,
    children: [
      { path: "/payment-request/pending", title: "Payment Requests", type: "link" },
      { path: "/payment-request-order/pending", title: "Order Request", type: "link" },
    ],
  },
  {
    title: "Localization",
    icon: Chrome,
    type: "sub",
    children: [
      { path: "/localization/currency-rates", title: "Currency Converter", type: "link" },
      { path: "/localization/shipping-charges", title: "Shipping charges", type: "link" },
    ],
  },
  {
    title: "Settings",
    icon: Settings,
    type: "sub",
    children: [
      { path: "/settings/profile", title: "Profile", type: "link" },
    ],
  },
  {
    title: "Admins",
    icon: UserPlus,
    type: "sub",
    active: false,
    children: [
      { path: "/admins/list-admin", title: "All Admins", type: "link" },
    ],
  },
];
